import { render, staticRenderFns } from "./SearchCompanyIds.vue?vue&type=template&id=6bb28dd8&scoped=true"
import script from "./SearchCompanyIds.vue?vue&type=script&lang=js"
export * from "./SearchCompanyIds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb28dd8",
  null
  
)

export default component.exports